var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7129 20H3.19826C1.46269 20 0.0507812 18.5982 0.0507812 16.875V6.28906C0.0507812 4.56589 1.46269 3.16406 3.19826 3.16406H10.7129C12.4484 3.16406 13.8604 4.56589 13.8604 6.28906V16.875C13.8604 18.5982 12.4484 20 10.7129 20ZM3.19826 4.72656C2.33055 4.72656 1.62452 5.42755 1.62452 6.28906V16.875C1.62452 17.7365 2.33055 18.4375 3.19826 18.4375H10.7129C11.5806 18.4375 12.2866 17.7365 12.2866 16.875V6.28906C12.2866 5.42755 11.5806 4.72656 10.7129 4.72656H3.19826ZM17.0078 14.9219V3.125C17.0078 1.40182 15.5959 0 13.8604 0H5.1261C4.69147 0 4.33923 0.349731 4.33923 0.78125C4.33923 1.21277 4.69147 1.5625 5.1261 1.5625H13.8604C14.7281 1.5625 15.4341 2.26349 15.4341 3.125V14.9219C15.4341 15.3534 15.7863 15.7031 16.221 15.7031C16.6556 15.7031 17.0078 15.3534 17.0078 14.9219Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCard);
export default __webpack_public_path__ + "static/media/doubleCard.93b3760b7b510225a009bbed640432df.svg";
export { ForwardRef as ReactComponent };